$(function () {
  if (!customElements.get('header-search')) {
    customElements.define(
      'header-search',
      class HeaderSearch extends HTMLElement {
        constructor() {
          super();
          this.timestamp = 0;
          this.$overlay;
          this.debouncedInputChange = this.debounce(this.inputChange.bind(this), 500);
        }

        connectedCallback() {
          this.init();
        }
        init() {
          this.initSwiper();
          this.initEvent();
        }
        initEvent() {
          const self = this;
          const root = $(this);
          const $inputMain = root.find('.input-main');
          const $input = root.find('.input-main input');
          const $searchInputIcon = root.find('.search-input-icon');
          const $closeInputIcon = root.find('.close-input-icon');
          const $searchIconBubble = $('#search-icon-bubble');
          const $searchMobileIcon = $('#search-mobile-icon');
          const $productViewAll = root.find('.product-view-all');
          const $blogViewAll = root.find('.blog-view-all');
          const $recommendedItem = root.find('.recommended-item');
          const $customerService = root.find('.customer-service .highlight');

          $inputMain.on('click', () => {
            $input.focus();
          });
          $input.on('focus', () => {
            root.attr('data-focus', 'true');
          });

          $input.on('input', (e) => {
            self.debouncedInputChange(e);
          });
          $input.on('keydown', (e) => {
            if (e.key === 'Enter') {
              if ($input.val().length > 0) {
                window.location.href = '/search?q=' + $input.val();
              }
            }
          });
          $searchInputIcon.on('click', () => {
            if ($input.val().length > 0) {
              window.location.href = '/search?q=' + $input.val();
            }
          });

          $closeInputIcon.on('click', () => {
            root.attr('data-show', 'false');
            $input.val('');
            root.attr('data-type', 'default');
            root.attr('data-loading', 'false');
            root.attr('data-focus', 'false');
            $('body').removeClass('no-scroll-important');
            $('.header-01').removeClass('transform-none-important');
            window.overlayManager.hide('header-search');
          });
          $searchIconBubble.on('click', () => {
            root.attr('data-show', 'true');
            $inputMain.click();
            $('body').addClass('no-scroll-important');
            this.$overlay = window.overlayManager.show('header-search');
            const ltHeader = document.querySelector('lt-header');
            ltHeader.closePopup();
            this.$overlay.on('click', () => {
              $closeInputIcon.click();
            });
          });

          $searchMobileIcon.on('click', () => {
            $('.header-01').addClass('transform-none-important');
            root.attr('data-focus', 'true');

            // 使用requestAnimationFrame确保在下一帧执行
            requestAnimationFrame(() => {
              // 监听transform过渡完成
              $('.header-01').one('transitionend', () => {
                root.attr('data-show', 'true');
                root.attr('data-type', 'default');
                $('body').addClass('no-scroll-important');
              });
            });
          });

          $productViewAll.on('click', () => {
            window.location.href = '/search?q=' + $input.val() + '&type=product';
          });
          $blogViewAll.on('click', () => {
            window.location.href = '/search?q=' + $input.val() + '&type=article';
          });
          $recommendedItem.on('click', (e) => {
            const $currentItem = $(e.currentTarget);
            const url = $currentItem.attr('data-url');
            const keyword = $currentItem.attr('data-keyword');
            if (url) {
              window.location.href = url;
            } else {
              $input.val(keyword);
              self.fetchData(keyword);
            }
          });
          $customerService.on('click', () => {
            window.litime.openChatApp();
          });
        }

        inputChange(e) {
          const self = this;
          const root = $(this);
          const value = e.target.value;
          if (value.length > 0) {
            self.fetchData(value);
          } else {
            const timestamp = new Date().getTime();
            this.timestamp = timestamp;
            root.attr('data-type', 'default');
          }
        }
        fetchData(value) {
          const self = this;
          const root = $(this);
          const timestamp = new Date().getTime();
          this.timestamp = timestamp;
          root.attr('data-loading', 'true');
          let data = {
            q: value.trim(),
            resources: {
              type: 'product,article',
              limit_scope: 'each',
            },
          };
          // 将data对象转换为URL查询参数
          const params = new URLSearchParams();
          params.append('q', data.q);
          params.append('resources[type]', data.resources.type);
          params.append('resources[limit_scope]', data.resources.limit_scope);

          // 生成完整的URL路径
          let url = window.Shopify.routes.root + `search/suggest.json?${params.toString()}`;
          fetch(url)
            .then((response) => response.json())
            .then((suggestions) => {
              const results = suggestions.resources.results;
              if (timestamp !== this.timestamp) {
                return;
              }
              if (results.products.length > 0 || results.articles.length > 0) {
                if (results.products.length > 0) {
                  let product_5 = results.products.slice(0, 5);
                  root
                    .find('.product-list')
                    .html(product_5.map((product) => this.itemTemplate(product.title, product.url, data.q)).join(''));
                } else {
                  root.find('.product-list').html(this.emptyText());
                }
                if (results.articles.length > 0) {
                  let article_5 = results.articles.slice(0, 5);
                  root
                    .find('.blog-list')
                    .html(article_5.map((article) => this.itemTemplate(article.title, article.url, data.q)).join(''));
                } else {
                  root.find('.blog-list').html(this.emptyText());
                }
                root.find('.total-count').text(results.products.length + results.articles.length);
                root.attr('data-type', 'result');
              } else {
                root.attr('data-type', 'empty');
                root.find('.total-count').text('0');
              }
              root.attr('data-loading', 'false');
            })
            .catch((error) => {
              console.error('Error fetching data:', error);
              if (timestamp != this.timestamp) {
                return;
              }
              root.attr('data-type', 'empty');
              root.attr('data-loading', 'false');
              root.find('.total-count').text('0');
            });
        }
        emptyText() {
          const root = $(this);
          const emptyText = root.attr('data-empty-text');
          return `<span class="empty-text">${emptyText}</span>`;
        }
        itemTemplate(title, url, q) {
          const highlight = title.replace(new RegExp(`(${q})`, 'gi'), '<span class="highlight">$1</span>');
          return `<a href="${url}" class="data-item">${highlight}</a>`;
        }
        initSwiper() {
          const self = this;
          const root = $(this);
          const $swiper = root.find('.my-swiper');
          const $buttonPrev = root.find('.swiper-button-prev');
          const $buttonNext = root.find('.swiper-button-next');
          new Swiper($swiper[0], {
            slidesPerView: 'auto',
            spaceBetween: 25,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            breakpoints: {
              576: {
                slidesOffsetBefore: 32,
                slidesOffsetAfter: 32,
              },
            },
            navigation: {
              nextEl: $buttonNext[0],
              prevEl: $buttonPrev[0],
            },
          });
        }
        debounce(fn, delay) {
          let timer = null;
          return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timer);
            timer = setTimeout(() => {
              fn.apply(context, args);
            }, delay);
          };
        }
      }
    );
  }
});
